import { render, staticRenderFns } from "./ComponentModal.vue?vue&type=template&id=19c67fce&"
import script from "./ComponentModal.vue?vue&type=script&lang=js&"
export * from "./ComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports